// ----------------------------------------------------------------------
// <copyright file="Izenda.TimeFormatConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// Expected format receive from BackEnd when using group by and date time

export default {
  DEFAULT_FORMAT_PATTERN: 'MM/dd/yyyy',
  DATE_TIME_FORMAT: {
    // setting template
    /*
        format : {
          FOR_DATE_SETTING: array of string,  // array of supported user's date format setting
          GROUP_BY: string,  // format group by, use for finding default format if current format not supported by user's date format setting
                            please prefer DEFAULT_FORMAT property of GROUP_BY section
          MOMENT_OUTPUT:  string // format define by moment
        }
       */

    /* Short Date*/
    'MM/dd/yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'MM/DD/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'M/d/yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'M/D/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'MM/dd/yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'MM/DD/YY',
      INTERVAL_VALUE: 'd'
    },
    'M/d/yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'M/D/YY',
      INTERVAL_VALUE: 'd'
    },
    'dd/MM/yyyy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'DD/MM/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'd/M/yyyy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'D/M/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'dd/MM/yy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'DD/MM/YY',
      INTERVAL_VALUE: 'd'
    },
    'd/M/yy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'D/M/YY',
      INTERVAL_VALUE: 'd'
    },
    'yyyy/MM/dd': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'YYYY/MM/DD',
      INTERVAL_VALUE: 'd'
    },
    'yyyy/M/d': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'YYYY/M/D',
      INTERVAL_VALUE: 'd'
    },
    'MM-yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MM-YY',
      INTERVAL_VALUE: 'M'
    },
    'M-yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'M-YY',
      INTERVAL_VALUE: 'M'
    },
    'MM-yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MM-YYYY',
      INTERVAL_VALUE: 'M'
    },
    'M-yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'M-YYYY',
      INTERVAL_VALUE: 'M'
    },
    'yy-MM': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YY-MM',
      INTERVAL_VALUE: 'M'
    },
    'yy-M': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YY-M',
      INTERVAL_VALUE: 'M'
    },
    'yyyy-MM': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YYYY-MM',
      INTERVAL_VALUE: 'M'
    },
    'yyyy-M': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YYYY-M',
      INTERVAL_VALUE: 'M'
    },
    /* Long date*/
    '[Month Name]-yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MMMM-YY',
      INTERVAL_VALUE: 'M'
    },
    '[Month Name]-yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MMMM-YYYY',
      INTERVAL_VALUE: 'M'
    },
    'yyyy-[Month Name]': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YYYY-MMMM',
      INTERVAL_VALUE: 'M'
    },
    'yy-[Month Name]': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YY-MMMM',
      INTERVAL_VALUE: 'M'
    },
    '[Day Names of the Week], [Month Name] dd, yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'dddd, MMMM DD, YYYY',
      INTERVAL_VALUE: 'd'
    },
    '[Day Names of the Week], [Month Name] d, yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'dddd, MMMM D, YYYY',
      INTERVAL_VALUE: 'd'
    },
    Day: {
      GROUP_BY: 'day',
      MOMENT_OUTPUT: 'DD',
      INTERVAL_VALUE: 'd'
    },
    Month: {
      GROUP_BY: 'month',
      MOMENT_OUTPUT: 'MM',
      INTERVAL_VALUE: 'M'
    },
    Year: {
      GROUP_BY: 'year',
      MOMENT_OUTPUT: 'YYYY',
      INTERVAL_VALUE: 'y'
    },
    'Month Name': {
      GROUP_BY: 'month',
      MOMENT_OUTPUT: 'MMMM',
      INTERVAL_VALUE: 'M'
    },
    'Day of Week': {
      GROUP_BY: 'weekday',
      MOMENT_OUTPUT: 'dddd',
      INTERVAL_VALUE: 'd'
    },
    Date: {
      GROUP_BY: 'date', // special case which depend on user setting
      INTERVAL_VALUE: 'd'
    },
    'Week Number': {
      GROUP_BY: 'weeknumber',
      MOMENT_OUTPUT: '[Week] WW - YYYY',
      INTERVAL_VALUE: 'w'
    },
    'yyyy - Qtr': {
      GROUP_BY: 'yearandquarter',
      MOMENT_OUTPUT: 'YYYY[ - Q]Q',
      INTERVAL_VALUE: 'Q'
    },
    Qtr: {
      GROUP_BY: 'quarter',
      MOMENT_OUTPUT: '[Q]Q',
      INTERVAL_VALUE: 'Q'
    },

    /* Short Hour */
    'HH:mm tt (12-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'hh:mm A',
      INTERVAL_VALUE: 'm'
    },
    'H:mm tt (12-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'h:mm A',
      INTERVAL_VALUE: 'm'
    },
    'HH:mm (24-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'HH:mm',
      INTERVAL_VALUE: 'm'
    },
    'H:mm (24-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'H:mm',
      INTERVAL_VALUE: 'm'
    },
    /* Long Hour */
    'HH:mm:ss tt': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'H:mm:ss tt': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'h:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'HH:mm:ss': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'H:mm:ss': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'H:mm:ss',
      INTERVAL_VALUE: 's'
    },

    /* Short Date & Long Hour – It should separate into 2 groups: 12-hour and 24-hour */
    /* 12-hour */
    'MM/dd/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M/d/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'MM/dd/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M/d/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'd/M/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'd/M/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy/MM/dd HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/MM/DD hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy/M/d HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/M/D hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'MM-yy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M-yy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'MM-yyyy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M-yyyy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yy-MM HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-MM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yy-M HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-M hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy-MM HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy-M HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-M hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },

    /* 24-hour */
    'MM/dd/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M/d/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'MM/dd/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M/d/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'd/M/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'd/M/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy/MM/dd HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/MM/DD HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy/M/d HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/M/D HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'MM-yy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M-yy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'MM-yyyy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M-yyyy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yy-MM HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'YY-MM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yy-M HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'YY-M HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy-MM HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy-M HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-M HH:mm:ss',
      INTERVAL_VALUE: 's'
    },

    /* Long Date & Long Hour – It should separate into 2 groups: 12-hour and 24-hour */
    /* 12-hour */
    '[Month Name]-yy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    '[Month Name]-yyyy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy-[Month Name] HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MMMM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yy-[Month Name] HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-MMMM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] dd, yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM DD, YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] d, yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM D, YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },

    /* 24-hour */
    '[Month Name]-yy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    '[Month Name]-yyyy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy-[Month Name] HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MMMM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yy-[Month Name] HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-MMMM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] dd, yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM DD, YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] d, yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM D, YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    }
  },
  GROUP_BY: {
    // setting template
    /*
          groupByType : {
            SETTINGS_VALUE_TYPE: array // list of supported setting by range drop down options
                                      // posible value : ['value', 'rangeValue']
            GROUP_BY_EXPECTED_FORMAT : string // expected format receive from fusion when function is group
            RANGE_CYCLE: boolean // define if setting by range can define from > to. example : From December to May. if false we will validate from and to value
            COMPARE_FORMAT: 'string' // standize format to compare between fusion value in setting value. we force all data into same format for easier to compare.
            DEFAULT_FORMAT: object // define alternative format if current format not supported by user's date format setting.
                                  // Must have 3 property match with 3 value in user's date format setting
            DISPLAY_DATE_FORMAT : string | object // display format for date picker
                                  //if this format depend on user's date time setting provide object with 3 property match with 3 value in user's date format setting
            NUMBER_PICKER_PROPS : object // Inpect props for Number picker
            DATE_PICKER_PROPS : object // Inpect props for Date Time picker
          }
         */
    day: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'D',
      NUMBER_PICKER_PROPS: {
        min: 1,
        max: 31
      },
      RANGE_CYCLE: true,
      COMPARE_FORMAT: 'DD'
    },
    month: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'M',
      NUMBER_PICKER_PROPS: {
        min: 1,
        max: 12
      },
      RANGE_CYCLE: true,
      COMPARE_FORMAT: 'MM'
    },
    year: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'YYYY',
      COMPARE_FORMAT: 'YYYY'
    },
    weekday: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'E',
      COMPARE_FORMAT: 'E',
      DISPLAY_DATE_FORMAT: 'dddd'
    },
    date: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M-D',
      COMPARE_FORMAT: 'YYYY-MM-DD',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yyyy/MM/dd',
        'MM/DD/YYYY': 'MM/dd/yyyy',
        'DD/MM/YYYY': 'dd/MM/yyyy'
      }
    },
    weeknumber: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-W',
      COMPARE_FORMAT: 'YYYY-WW',
      DISPLAY_DATE_FORMAT: '[Week] WW - YYYY'
    },
    yearandquarter: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true,
        initialView: 'year'
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-Q',
      COMPARE_FORMAT: 'YYYY-Q',
      DISPLAY_DATE_FORMAT: 'YYYY-[Q]Q'
    },
    quarter: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      NUMBER_PICKER_PROPS: {
        min: 1,
        max: 4
      },
      GROUP_BY_EXPECTED_FORMAT: 'Q',
      RANGE_CYCLE: true,
      COMPARE_FORMAT: 'Q'
    },
    yearandmonth: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true,
        initialView: 'year'
      },
      DISPLAY_DATE_FORMAT: {
        'YYYY/MM/DD': 'YYYY-MM',
        'MM/DD/YYYY': 'MM-YYYY',
        'DD/MM/YYYY': 'MM-YYYY'
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M',
      COMPARE_FORMAT: 'YYYY-MM',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yy-MM',
        'MM/DD/YYYY': 'MM-yy',
        'DD/MM/YYYY': 'MM-yy'
      }
    },
    time: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'H:m:s',
      RANGE_CYCLE: true,
      DATE_PICKER_PROPS: {
        time: true,
        calendar: false
      },
      COMPARE_FORMAT: 'HH:mm:ss'
    },
    dateandtime: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: true,
        calendar: true
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M-D H:m:s',
      COMPARE_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yyyy/MM/dd HH:mm:ss tt',
        'MM/DD/YYYY': 'MM/dd/yyyy HH:mm:ss tt',
        'DD/MM/YYYY': 'dd/MM/yyyy HH:mm:ss tt'
      }
    },
    yearmonthandtime: {
      SETTINGS_VALUE_TYPE: ['value'],
      DATE_PICKER_PROPS: {
        time: true,
        calendar: true
      },
      DISPLAY_DATE_FORMAT: {
        'YYYY/MM/DD': 'YYYY-MM HH:mm:ss',
        'MM/DD/YYYY': 'MM-YYYY HH:mm:ss',
        'DD/MM/YYYY': 'MM-YYYY HH:mm:ss'
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M H:m:s',
      COMPARE_FORMAT: 'YYYY-MMTHH:mm:ss',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yy-MM HH:mm:ss tt',
        'MM/DD/YYYY': 'MM-yy HH:mm:ss tt',
        'DD/MM/YYYY': 'MM-yy HH:mm:ss tt'
      }
    }
  },
  DAY_OF_WEEK_VALUES: [, 7, 1, 2, 3, 4, 5, 6]
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.TimeFormatConstants.js